import { styled, Typography } from "@mui/material";
import { BLACK } from "styles/colors";

export const SelectAPackage = styled(Typography)({
  color: BLACK[87],
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.25px",
});
